module.exports = __webpack_public_path__ + "static/media/social_twitter_gray.0a216a7b.svg";